;(function () {
  window.Ateed.MenuLevel = function(parent, node, number, isVisible) {
    console.log('MenuLevel', parent, node, number, isVisible);
    var self = this;
    console.log(self);
    self.parent = parent || { uri: '', title: '' };
    var defaults = {title: '', uri: '', children: {}, imageCards: {}, isActive: false};
    Object.assign(self, defaults);
    console.log(self)
    if (node) {
      if (title in node) self.title = node.title;
      if (uri in node) self.uri = node.uri;
      if (children in node) self.children = node.children;
      if (imageCards in node) self.imageCards = node.imageCards;
      if (isActive in node) self.isActive = node.isActive;
    }
    self.number = number;
    self.isVisible = isVisible;
    self.deepCss = number > 2 ? 'ateed-deep-level' : '';
    console.log(self)
  };
})();
